"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.callOutcomeElaborations = void 0;
var callOutcomeElaborations;
(function (callOutcomeElaborations) {
    callOutcomeElaborations["VM_IS_NOT_NECESSARY"] = "VM is not necessary";
    callOutcomeElaborations["INVALID_NUMBER"] = "Invalid number";
    callOutcomeElaborations["BUSY_TONE"] = "Busy tone";
    callOutcomeElaborations["ABANDONED_CALL"] = "Abandoned call";
    callOutcomeElaborations["CALL_HANG_UP_BEFORE_CONNECTION"] = "Hang Up before connection";
    callOutcomeElaborations["NO_ANSWER"] = "No answer";
    callOutcomeElaborations["UNREACHABLE"] = "Unreachable";
    callOutcomeElaborations["ANSWERING_MACHINE"] = "Dialer reached answering machine, call wasn\u2019t connected to an agent";
})(callOutcomeElaborations || (exports.callOutcomeElaborations = callOutcomeElaborations = {}));
